var installedModules = {};
var moduleToHandlerMapping = {
	58775: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(74848); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	12878: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(96540); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	42115: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	84106: {
		getter: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(8884)]).then(function() { return function() { return __webpack_require__(40961); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	16435: {
		getter: function() { return __webpack_require__.e(7334).then(function() { return function() { return __webpack_require__(14953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	10297: {
		getter: function() { return Promise.all([__webpack_require__.e(7967), __webpack_require__.e(1688), __webpack_require__.e(1298), __webpack_require__.e(4106), __webpack_require__.e(1226)]).then(function() { return function() { return __webpack_require__(86715); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	43589: {
		getter: function() { return Promise.all([__webpack_require__.e(1688), __webpack_require__.e(4106), __webpack_require__.e(6473)]).then(function() { return function() { return __webpack_require__(28133); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	73454: {
		getter: function() { return Promise.all([__webpack_require__.e(3651), __webpack_require__.e(8884)]).then(function() { return function() { return __webpack_require__(23651); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.3.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	75535: {
		getter: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(4106), __webpack_require__.e(508)]).then(function() { return function() { return __webpack_require__(29965); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	73427: {
		getter: function() { return Promise.all([__webpack_require__.e(7967), __webpack_require__.e(1106)]).then(function() { return function() { return __webpack_require__(91106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	7044: {
		getter: function() { return __webpack_require__.e(4353).then(function() { return function() { return __webpack_require__(74353); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.10.8",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	70810: {
		getter: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^8.1.1-canary.54 || >=9.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	26938: {
		getter: function() { return __webpack_require__.e(7334).then(function() { return function() { return __webpack_require__(14953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	96844: {
		getter: function() { return __webpack_require__.e(8606).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	39526: {
		getter: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(4106)]).then(function() { return function() { return __webpack_require__(29965); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	43992: {
		getter: function() { return Promise.all([__webpack_require__.e(7967), __webpack_require__.e(1106), __webpack_require__.e(2413)]).then(function() { return function() { return __webpack_require__(91106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	38914: {
		getter: function() { return Promise.all([__webpack_require__.e(1688), __webpack_require__.e(4106), __webpack_require__.e(3889)]).then(function() { return function() { return __webpack_require__(28133); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	35061: {
		getter: function() { return __webpack_require__.e(2274).then(function() { return function() { return __webpack_require__(29893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	4072: {
		getter: function() { return __webpack_require__.e(8903).then(function() { return function() { return __webpack_require__(31284); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	31343: {
		getter: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	}
};
var initialConsumes = [58775,12878,42115,84106,16435,10297,43589,73454,75535,73427,7044,70810,31343];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"297": [
		10297
	],
	"636": [
		16435,
		10297,
		43589,
		73454,
		75535,
		73427,
		7044,
		70810
	],
	"810": [
		70810
	],
	"1343": [
		31343
	],
	"1836": [
		73427,
		7044,
		16435
	],
	"3454": [
		73454
	],
	"3589": [
		43589
	],
	"4106": [
		84106
	],
	"5120": [
		26938,
		96844,
		39526,
		43992,
		38914,
		35061,
		4072
	],
	"5535": [
		75535
	],
	"8775": [
		58775
	],
	"8792": [
		58775,
		12878,
		42115,
		84106
	],
	"8884": [
		12878
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}